import request from '@/config/axios'

// AI 音乐 VO
export interface MusicVO {
  id: number // 编号
  userId: number // 用户编号
  title: string // 音乐名称
  lyric: string // 歌词
  imageUrl: string // 图片地址
  audioUrl: string // 音频地址
  videoUrl: string // 视频地址
  status: number // 音乐状态
  gptDescriptionPrompt: string // 描述词
  prompt: string // 提示词
  platform: string // 模型平台
  model: string // 模型
  generateMode: number // 生成模式
  tags: string // 音乐风格标签
  duration: number // 音乐时长
  publicStatus: boolean // 是否发布
  taskId: string // 任务id
  errorMessage: string // 错误信息
  createTime?: string | number // 创建时间
}

// AI 音乐 API
export const MusicApi = {
  /** 创建音乐生成任务 */
  generateMusic: async (data: {
    platform: string
    generateMode: number
    prompt: string
    makeInstrumental?: boolean
    model: string
    tags?: string[]
    title?: string
  }) => {
    return await request.post({ url: '/ai/music/generate', data })
  },

  /** 查询当前用户的音乐任务 */
  getMyMusicPage: async (params: any) => {
    return await request.get({ url: '/ai/music/my-page', params })
  },

  // 查询音乐分页
  getMusicPage: async (params: any) => {
    return await request.get({ url: `/ai/music/page`, params })
  },

  // 更新音乐
  updateMusic: async (data: any) => {
    return await request.put({ url: '/ai/music/update', data })
  },

  // 删除音乐
  deleteMusic: async (id: number) => {
    return await request.delete({ url: `/ai/music/delete?id=` + id })
  },

  /** 获得音乐详情 */
  getMusicDetail: async (id: number) => {
    return await request.get({ url: `/ai/music/get?id=` + id })
  }
}
